export const UPDATE_COUNTS = '/app/store/payApprovals/UPDATE_TAB_COUNTS'
export const UPDATE_LAST_TAB = '/app/store/payApprovals/UPDATE_LAST_TAB'
export const UPDATE_SHOW_BUDGET_PENDING_AMOUNTS =
  '/app/store/payApprovals/UPDATE_SHOW_BUDGET_PENDING_AMOUNTS'
